import React from 'react'
import NotFound from '../../shared/NotFound'
import * as modelEditors from '../modelEditors/index'

const EditorResolver = props => {
  const { object: { __typename, rid }} = props
  const Editor = modelEditors[`${__typename}Editor`] || NotFound

  return (
    <Editor key={`editor-${__typename}-${rid}`}
      {...props}
    />
  )
}

export default EditorResolver
